/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { ROUTES } from 'config/routes';
import logoSvg from 'assets/icons/silver-logo.svg';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, useLocation } from 'react-router-dom';
import {
  changeIsTabActive,
  fetchDisabledFeatures,
  getAndSetIsSideMenuPinned, setScreenSize,
} from '../../redux_store/reducer/reducers/appSettingsReducer';
import useNotifier from '../Notifications/useNotifier';
import {
  changeCurrentAccountForAlertsNotifications,
  startAlertsConnection,
} from '../../redux_store/reducer/middleware/alertsMiddleware';
import { UserContext } from '../../contexts';
import { fetchTableSettings } from '../../redux_store/reducer/reducers/tableReducer/api';
import { getAndSetIsInfoPaneExpanded } from '../../redux_store/reducer/reducers/infoPaneReducer';
import ProtectedRoute from './widgets/ProtectedRoute';
import PublicRoute from './widgets/PublicRoute';
import EnvTopBar from './widgets/EnvTopBar';
import Idle from './widgets/Idle';
import { ToastContainer } from 'react-toastify';
import NotFound from '../Public/NotFound';
import PageLoader from '../Shared/PageLoader';
import { getAlertTags } from '../../redux_store/reducer/reducers/alertsReducer/api';

const useStyles = makeStyles((theme) => ({
  main: {
    height: '100vh',
    position: 'relative',
    backgroundImage: `url(${logoSvg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '60%',
    backgroundPosition: '115% 20%',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '100%',
      backgroundColor: theme.colors.gray3,
      zIndex: -1,
    },
  },
}));

const App = () => {
  useNotifier();
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isLogin, user, metadata } = useSelector((state) => state.user);
  const { changeAccountLoading } = useContext(UserContext);
  const [showContent, setShowContent] = useState(false);
  const [isLoaderHiding, setIsLoaderHiding] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  const isLoginPage = location.pathname.startsWith('/login');

  useEffect(() => {
    if (!changeAccountLoading) {
      // Сразу показываем контент под лоадером
      setShowContent(true);

      // Для login страниц используем сокращенные таймеры
      const renderDelay = isLoginPage ? 100 : 300;
      const animationDuration = isLoginPage ? 150 : 400;

      // Через renderDelay даем время для рендера контента, затем начинаем исчезновение лоадера
      const hideTimer = setTimeout(() => {
        setIsLoaderHiding(true);

        // Через animationDuration убираем лоадер из DOM
        const removeTimer = setTimeout(() => {
          setShowLoader(false);
        }, animationDuration);

        return () => clearTimeout(removeTimer);
      }, renderDelay);

      return () => clearTimeout(hideTimer);
    } else {
      setShowContent(false);
      setIsLoaderHiding(false);
      setShowLoader(true);
    }
  }, [changeAccountLoading, isLoginPage]);

  useEffect(() => {
    dispatch(getAndSetIsSideMenuPinned());
    dispatch(getAndSetIsInfoPaneExpanded());
    dispatch(fetchDisabledFeatures());
    if (isLogin) {
      dispatch(getAlertTags());
    }
  }, []);

  useEffect(() => {
    if (isLogin && !user) {
      dispatch(getAlertTags());
      dispatch(fetchTableSettings());
      startAlertsConnection();
    }
  }, [isLogin]);

  useEffect(() => {
    if (metadata?.currentAccount?.uuid) {
      dispatch(changeCurrentAccountForAlertsNotifications(metadata?.currentAccount?.uuid));
    }
  }, [metadata?.currentAccount?.uuid]);

  useEffect(() => {
    const updateScreenSize = () => {
      dispatch(setScreenSize({
        height: window.innerHeight,
        width: window.innerWidth,
      }));
    };

    window.addEventListener('resize', updateScreenSize);
    return () => {
      window.removeEventListener('resize', updateScreenSize);
    };
  }, []);

  return (<>
      <ToastContainer />
      <_CheckTabActivity />
      <Idle />
      <main className={classes.main}>
        <EnvTopBar />
        {/* Контент всегда рендерится, но показывается только когда готов */}
        {showContent && (
          <Routes>
            {ROUTES.map((route) => {
              const { additional } = route;
              return additional.protected ? (
                <Route
                  exact
                  path={route.path}
                  element={
                    <ProtectedRoute key={route.path || ''} {...route} />
                  }
                />
              ) : (
                <Route
                  exact
                  path={route.path}
                  element={
                    <PublicRoute key={route.path || ''} {...route} />
                  }
                />
              );
            })}
            <Route path='*' element={<NotFound />} />
          </Routes>
        )}

        {/* Лоадер поверх контента (не показываем на login страницах) */}
        {showLoader && !isLoginPage && (
          <PageLoader isHiding={isLoaderHiding} />
        )}
      </main>
    </>
  );
};

export default App;

const _CheckTabActivity = () => {
  const dispatch = useDispatch();

  function handleActivity(forcedFlag) {
    if (typeof forcedFlag === 'boolean') {
      return dispatch(changeIsTabActive(forcedFlag));
    }
    return dispatch(changeIsTabActive(!document.hidden));
  }

  function setContentHidden() {
    handleActivity(false);
  }

  function setContentShown() {
    handleActivity(true);
  }

  useEffect(() => {
    window.onfocus = setContentShown;
    document.onvisibilitychange = () => {
      if (document.visibilityState === 'hidden') {
        setContentHidden();
      }
      if (document.visibilityState === 'visible') {
        setContentShown();
      }
    };

    window.addEventListener('focus', setContentShown);
    document.addEventListener('visibilitychange', handleActivity);
    return () => {
      window.removeEventListener('focus', setContentShown);
      document.removeEventListener('visibilitychange', handleActivity);
    };
  }, []);

  return <></>;
};
